// extracted by mini-css-extract-plugin
export default {"space":"space_space__-DE0a"};